import React from "react";
import "./style.css";
import {QuestionnaireMultiple} from "../../../../components/QuestionnaireMultiple";
import {SKIN_CHANGES} from "../../../../const/FastingQuestionnaire";

export const SkinChanges = (props) => {
    const list = {
        title: "Is there anything you want to change about your skin?",
        list: SKIN_CHANGES
    };

    return (
        <div className="gallery-page skin-changes-page">
            <QuestionnaireMultiple {...props} list={list} />
        </div>
    );
};
